module.exports = __webpack_public_path__ + "static/media/loader.0f23892a.gif";